import { IDocument } from '@common/types';
import { Button } from '@components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ISourcesDropdownProps {
  sourceDocuments?: Array<Pick<IDocument, 'id' | 'displayName' | 'externalDocumentLink'>>;
}

function SourcesDropdown(props: ISourcesDropdownProps) {
  const { t } = useTranslation();

  if (props.sourceDocuments?.length) {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            className="bg-slate-200 border-none text-black/90 hover:bg-slate-500 hover:text-slate-100 w-full"
            variant="outline"
          >
            {t('common.sources')} <ChevronDown />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-full">
          {props.sourceDocuments.map((doc, idx) => (
            <DropdownMenuItem key={doc.id}>
              <a href={doc.externalDocumentLink} target="_blank" className="text-xs sm:text-base">
                {`[${idx}] ${doc.displayName || 'Document'} `}
              </a>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }
  return null;
}

export default SourcesDropdown;
